import { DateInput, DateTimeInput, Field, NumericInput, TextOutput, TimeInput } from 'Components/Core';
import { DATETIME_INPUT_COLUMN_WIDTH, DateTimeStyle } from 'Components/Layout/Grid/types';
import { RecordGridField, RecordGridFieldSet } from 'Components/Worksheets/Core';
import { TareId } from 'Components/Worksheets/Core/Fields/TareId';
import { DateTimeDataFormat } from 'Lib/Format';
import { toWordsOrdinal } from 'number-to-words';

export const getDryMassGridFieldSet = (
  dryMassEntryOption: any,
  dateTimeStyle: DateTimeStyle = DateTimeStyle.Separate
): Array<RecordGridField> => [
  {
    name: 'DateTimeRemovedFromOvenLocal',
    component: <Field input={<DateInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
    hidden: dryMassEntryOption === 'Never' || dateTimeStyle === DateTimeStyle.Combined,
    label: 'Date Out of Oven',
  },
  {
    name: 'DateTimeRemovedFromOvenLocal',
    component: <Field input={<TimeInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
    hidden: dryMassEntryOption === 'Never' || dateTimeStyle === DateTimeStyle.Combined,
    label: 'Time Out of Oven',
  },
  {
    name: 'DateTimeRemovedFromOvenLocal',
    component: <Field input={<DateTimeInput />} />,
    hidden: dryMassEntryOption === 'Never' || dateTimeStyle === DateTimeStyle.Separate,
    label: 'Date and Time out of oven',
    width: DATETIME_INPUT_COLUMN_WIDTH,
  },
  {
    name: 'DryingTime',
    component: <Field input={<TextOutput />} />,
    hidden: dryMassEntryOption === 'Never',
  },
  {
    name: 'DrySoilAndContainerMass',
    // We do not show the dry mass calculated from the Tare + Dry mass, so we need to show its messages on this field
    additionalMessagePaths: ['DrySoilMass'],
    component: <Field input={<NumericInput />} />,
    label: 'Tare & Dry Mass (g)', // shortened
  },
];

export const getGridFieldSet = (
  dryMassEntryOption: any,
  dateTimeStyle: DateTimeStyle = DateTimeStyle.Separate
): RecordGridFieldSet => [
  {
    name: 'DryingTray.ContainerLabel',
    component: <TareId inGrid />,
  },
  {
    name: 'DryingTray.ContainerMass',
    component: <Field input={<NumericInput />} />,
  },
  {
    name: 'DryingTray.WetSoilAndContainerMass',
    // We do not show the wet mass calculated from the Tare + Wet mass, so we need to show its messages on this field
    additionalMessagePaths: ['DryingTray.WetSoilMass'],
    component: <Field input={<NumericInput />} />,
    label: 'Tare & Wet Mass (g)', // shortened
  },
  {
    name: 'DryingTray.DateTimePlacedInOvenLocal',
    component: <Field input={<DateInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
    hidden: dryMassEntryOption === 'Never',
    label: 'Date in Oven',
  },
  {
    name: 'DryingTray.DateTimePlacedInOvenLocal',
    component: <Field input={<TimeInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
    hidden: dryMassEntryOption === 'Never',
    label: 'Time in Oven',
  },
  {
    name: 'DryingTray.DryMassReadings',
    recordProps: {
      heading:
        dryMassEntryOption !== 'Never'
          ? (i: number) => (i > 0 ? `${toWordsOrdinal(i + 1)} Drying` : 'Drying')
          : undefined,
      enforceAtLeastOneRecord: true,
      preventRemove: 'all-but-last',
      preventCreate: dryMassEntryOption === 'Never',
      removeConfirm: {
        confirm: true,
        confirmTitle: 'Delete Dry Mass Reading',
        confirmText: 'Are you sure you want to delete the dry mass reading? Data cannot be recovered.',
        confirmButtonText: 'Delete',
      },
    },
    fields: getDryMassGridFieldSet(dryMassEntryOption, dateTimeStyle),
  },
  {
    name: 'Results.MoistureContentPercent',
    component: <Field input={<TextOutput />} />,
  },
];
